import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import Invoice from "components/Invoices/invoice"

import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { INVOICING } from "constants/entitlements"

const InvoicesIndex = () => {
  return (
    <EntitlementPageGuard permission={INVOICING}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Facturas</title>
        </Helmet>
        <Container fluid>
          <Invoice />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default InvoicesIndex
